module.exports = __webpack_public_path__ + "img/LREX-Hero-Image.4638af2c.png";